import React, { forwardRef, useState, useEffect, useRef, useCallback } from 'react';
import emailjs from 'emailjs-com';
import { FaChevronUp } from 'react-icons/fa';
import {  animateScroll as scroll } from 'react-scroll';
import { ContactStyles } from '../styles/contact.style';
import validation from '../helper/validation';

const Contact = forwardRef((props, inputRef ) => {

    const form = useRef();

    const [data, setData] = useState({
        username: '',
        userEmail: '',
        mailSubject: '',
        mailMessage: ''
    })

    const [errors, setErrors] = useState({});
    const [isValid, setIsValid] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const { username, userEmail, mailSubject, mailMessage } = data;

    const handleChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

    const sendEmail = useCallback(async () => {
        try {
            const result = await emailjs.sendForm('service_ikaf4dq', 'template_547ohpb', form.current, 'user_oI03AvahLpXXOxxR0GmZj');
                 
            if(result) {
                return result.text;
           }
        } catch (error) {
            setErrors({ ...errors, server: 'internal server error'});
            return;
        }
    }, [errors])

    useEffect(() => {
        if(Object.keys(errors).length === 0 && isValid) {
            sendEmail();
            setFormSubmitted(true);
            setData({
                username: '',
                userEmail: '',
                mailSubject: '',
                mailMessage: ''
            });
        }
        let submitTimer = setTimeout(() => {
            setIsValid(false);
            setFormSubmitted(false);
        }, 5000);
        return () => {
            clearTimeout(submitTimer);
        }
    }, [errors, isValid, sendEmail])

    const handleSubmit = (e) => {
        e.preventDefault();
        
        setErrors(validation(data));
        setIsValid(true);
    }



    const scrollToTop = () => scroll.scrollToTop();
    
    return (
        <ContactStyles id="contact">
            <div className="container">
                <div className="row">
                    <div className="section__title">
                        <h2 data-heading="contact">Have a Question? or want to work together?</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="contact__form">
                        <form ref={form} onSubmit= { handleSubmit }>
                            <div className="row">
                                <div className="w-50">
                                    <div className="input__group outside-shadow hover-in-shadow">
                                        <input 
                                            type="text" 
                                            name="username"
                                            value={username}
                                            onChange={ (e) => handleChange(e) }
                                            className="input__control" 
                                            ref={inputRef}
                                            { ...props }
                                        />
                                        { errors.name && <p className="error-message">{errors.name}</p>}
                                    </div>
                                    <div className="input__group outside-shadow hover-in-shadow">
                                        <input 
                                            type="text" 
                                            name="userEmail"
                                            value={userEmail}
                                            onChange={ (e) => handleChange(e) }
                                            placeholder="Email" 
                                            className="input__control" 
                                        />
                                        { errors.email && <p className="error-message">{errors.email}</p>}
                                    </div>
                                    <div className="input__group outside-shadow hover-in-shadow">
                                        <input 
                                            type="text" 
                                            name="mailSubject"
                                            value={mailSubject}
                                            onChange={ (e) => handleChange(e) }
                                            placeholder="Subject" 
                                            className="input__control" 
                                        />
                                        { errors.subject && <p className="error-message">{errors.subject}</p>}
                                    </div>
                                </div>
                                <div className="w-50">
                                    <div className="input__group outside-shadow hover-in-shadow">
                                        <textarea 
                                            className="input__control" 
                                            placeholder="Message"
                                            name="mailMessage"
                                            onChange={ (e) => handleChange(e) }
                                            value={mailMessage}
                                        ></textarea>
                                        { errors.message && <p className="error-message">{errors.message}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ position: 'relative' }}>
                                { errors.server && <div className="failed">{errors.server}</div>}
                                { formSubmitted && <div className="success">Sent successfully, Thank You</div>}
                                <div className="submit__btn">
                                    <button type="submit" className="btn-link outside-shadow hover-in-shadow">Send Message</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="row">
                    <div className="arrow-box">
                        <button 
                            className="btn-link outside-shadow hover-in-shadow"
                            onClick={scrollToTop}
                        >
                            <FaChevronUp/>
                        </button>
                    </div>
                </div>
            </div>
        </ContactStyles>
    )
})

export default Contact;
